import {StyleSheet} from 'react-native'
import {IS_WEB, ThemeUtils} from "../../../utils";

export default StyleSheet.create({
    dashboardItem: {
        height: ThemeUtils.isTablet() ? ThemeUtils.relativeRealWidth(23) : ThemeUtils.relativeRealWidth(45),
        borderRadius: ThemeUtils.relativeRealWidth(2),
        aspectRatio:1
    },
    imgServices: {
        flex: 1,
        justifyContent: 'flex-end',
        borderRadius: ThemeUtils.relativeRealWidth(2),
        width: IS_WEB ? undefined : ThemeUtils.isTablet() ? ThemeUtils.relativeRealWidth(30) : ThemeUtils.relativeRealWidth(45)
    },
    imgServicesOverlay: {
        flex: 1,
        position:'absolute',
        top: 0,
        bottom: 0,
        end: 0,
        start: 0,
        justifyContent: 'flex-end',
        borderRadius: ThemeUtils.relativeRealWidth(2),
        // width: IS_WEB ? undefined : ThemeUtils.isTablet() ? ThemeUtils.relativeRealWidth(30) : ThemeUtils.relativeRealWidth(45)
    },
    lblCont: {
        flex: 1,
        justifyContent: 'flex-end',
        paddingHorizontal: ThemeUtils.relativeRealWidth(2),
        paddingVertical: ThemeUtils.relativeRealHeight(1)
    },
    dashBoardCont: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: ThemeUtils.relativeRealWidth(1)
    },
    singleBanner: {
        marginBottom: 15,
        marginStart: ThemeUtils.relativeRealWidth(2),
        height: ThemeUtils.relativeRealWidth(100) * 0.17,
        width: ThemeUtils.relativeRealWidth(92),
    },
    halfBanner: {
        marginBottom: 15,
        marginStart: ThemeUtils.relativeRealWidth(2),
        height: ThemeUtils.relativeRealWidth(100) * 0.35,
        width: ThemeUtils.relativeRealWidth(92),
    }
})
